<div class="card border-0 header">
  <h3>Obter Cargas</h3>
  <div class="card-body">
    <!-- https://getbootstrap.com/docs/4.0/utilities/display/ -->

    <div class="card mt-3">
      <div class="card-header text-uppercase">Gestores (Amplis)</div>
      <div class="card-body">
        <div class="row mb-2 tipos-cargas">
          <div class="col-9">
            <p>
              A carga de gestores é obtida automaticamente a cada 30 minutos,
              porém, se preferir, clique no botão para executar a carga
              manualmente. Os dados serão atualizados em aproximadamente 1
              minuto.
            </p>
          </div>
          <div class="col-3">
            <input
              type="button"
              value="Obter Carga de Gestores (Amplis)"
              class="btn btn-primary"
              [disabled]="!managersEnabled"
              (click)="getManagers()"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="card mt-3">
      <div class="card-header text-uppercase">Fundos (Amplis)</div>
      <div class="card-body">
        <div class="row mb-2 tipos-cargas">
          <div class="col-9">
            <p>
              A carga de fundos é obtida automaticamente a cada 30 minutos,
              porém, se preferir, clique no botão para executar a carga
              manualmente. Os dados serão atualizados em aproximadamente 1
              minuto.
            </p>
          </div>
          <div class="col-3">
            <input
              type="button"
              value="Obter Carga de Fundos (Amplis)"
              class="btn btn-primary"
              [disabled]="!fundsEnabled"
              (click)="getFunds()"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="card mt-3">
      <div class="card-header text-uppercase">Contas de Fundos (Amplis)</div>
      <div class="card-body">
        <div class="row mb-2 tipos-cargas">
          <div class="col-9">
            <p>
              A carga de contas de fundos é obtida automaticamente a cada 30
              minutos, porém, se preferir, clique no botão para executar a carga
              manualmente. Os dados serão atualizados em aproximadamente 1
              minuto.
            </p>
          </div>
          <div class="col-3">
            <input
              type="button"
              value="Obter Carga de Contas (Amplis)"
              class="btn btn-primary"
              [disabled]="!accountsEnabled"
              (click)="getAccounts()"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="card mt-3">
      <div class="card-header text-uppercase">Fundos Investidos (Amplis)</div>
      <div class="card-body">
        <div class="row mb-2 tipos-cargas">
          <div class="col-9">
            <p>
              A carga de fundos investidos é obtida automaticamente a cada 30
              minutos, porém, se preferir, clique no botão para executar a carga
              manualmente. Os dados serão atualizados em aproximadamente 1
              minuto.
            </p>
          </div>
          <div class="col-3">
            <input
              type="button"
              value="Obter Carga de Fundos Investidos (Amplis)"
              class="btn btn-primary"
              [disabled]="!investedFundsEnabled"
              (click)="getInvestedFunds()"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="card mt-3">
      <div class="card-header text-uppercase">Lastro (Amplis)</div>
      <div class="card-body">
        <div class="row mb-2 tipos-cargas">
          <div class="col-9">
            <p>
              A carga de lastro é obtida automaticamente a cada 30 minutos,
              porém, se preferir, clique no botão para executar a carga
              manualmente. Os dados serão atualizados em aproximadamente 1
              minuto.
            </p>
          </div>
          <div class="col-3">
            <input
              type="button"
              value="Obter Carga de Lastro (Amplis)"
              class="btn btn-primary"
              [disabled]="!ballastEnabled"
              (click)="getBallast()"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="card mt-3">
      <div class="card-header text-uppercase">Estoque de Fundos (Amplis)</div>
      <div class="card-body">
        <div class="row mb-2 tipos-cargas">
          <div class="col-9">
            <p>
              A carga de estoque de fundos é obtida automaticamente uma vez por
              dia, porém, se preferir, clique no botão para executar a carga
              manualmente. Os dados serão atualizados em aproximadamente 5
              minutos.
            </p>
          </div>
          <div class="col-3">
            <input
              type="button"
              value="Obter Carga de Estoque de Fundos (Amplis)"
              class="btn btn-primary"
              [disabled]="!fundStockEnabled"
              (click)="getFundStock()"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="card mt-3">
      <div class="card-header text-uppercase">
        Estoque de Renda Fixa (Amplis)
      </div>
      <div class="card-body">
        <div class="row mb-2 tipos-cargas">
          <div class="col-9">
            <p>
              A carga de estoque de Renda Fixa é obtida automaticamente uma vez
              por dia, porém, se preferir, clique no botão para executar a carga
              manualmente. Os dados serão atualizados em aproximadamente 5
              minutos.
            </p>
          </div>
          <div class="col-3">
            <input
              type="button"
              value="Obter Carga de Estoque de Renda Fixa (Amplis)"
              class="btn btn-primary"
              [disabled]="!fixedIncomeEnabled"
              (click)="getFixedIncomeStock()"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="card mt-3">
      <div class="card-header text-uppercase">
        Estoque de Renda Variável (Amplis)
      </div>
      <div class="card-body">
        <div class="row mb-2 tipos-cargas">
          <div class="col-9">
            <p>
              A carga de estoque de Renda Variável é obtida automaticamente uma
              vez por dia, porém, se preferir, clique no botão para executar a
              carga manualmente. Os dados serão atualizados em aproximadamente 5
              minutos.
            </p>
          </div>
          <div class="col-3">
            <input
              type="button"
              value="Obter Carga de Estoque de Renda Variável (Amplis)"
              class="btn btn-primary"
              [disabled]="!variableIncomeEnabled"
              (click)="getVariableIncomeStock()"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="card mt-3">
      <div class="card-header text-uppercase">
        Estoque de Derivativos (Amplis)
      </div>
      <div class="card-body">
        <div class="row mb-2 tipos-cargas">
          <div class="col-9">
            <p>
              A carga de estoque de Derivativos é obtida automaticamente uma vez
              por dia, porém, se preferir, clique no botão para executar a carga
              manualmente. Os dados serão atualizados em aproximadamente 5
              minutos.
            </p>
          </div>
          <div class="col-3">
            <input
              type="button"
              value="Obter Carga de Estoque de Derivativos (Amplis)"
              class="btn btn-primary"
              [disabled]="!derivativeEnabled"
              (click)="getDerivativeStock()"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="card mt-3">
      <div class="card-header text-uppercase">
        Estoque de Outros Ativos (Amplis)
      </div>
      <div class="card-body">
        <div class="row mb-2 tipos-cargas">
          <div class="col-9">
            <p>
              A carga de estoque de Outros Ativos é obtida automaticamente uma
              vez por dia, porém, se preferir, clique no botão para executar a
              carga manualmente. Os dados serão atualizados em aproximadamente 5
              minutos.
            </p>
          </div>
          <div class="col-3">
            <input
              type="button"
              value="Obter Carga de Estoque de Outros Ativos (Amplis)"
              class="btn btn-primary"
              [disabled]="!otherAssetEnabled"
              (click)="getOtherAssetStock()"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="card mt-3">
      <div class="card-header text-uppercase">ESTOQUE DE Swap-CETIP (Amplis)</div>
      <div class="card-body">
        <div class="row mb-2 tipos-cargas">
          <div class="col-9">
            <p>
              A Swap-CETIP investidos é obtido automaticamente a cada 5
              minutos, porém, se preferir, clique no botão para executar a carga
              manualmente. Os dados serão atualizados em aproximadamente 1
              minuto.
            </p>
          </div>
          <div class="col-3">
            <input
              type="button"
              value="Obter Carga de Estoque Swap-CETIP (Amplis)"
              class="btn btn-primary"
              [disabled]="!swapCetipEnabled"
              (click)="getSwapCetipStock()"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="card mt-3">
      <div class="card-header text-uppercase">Cotistas (JCOT)</div>
      <div class="card-body">
        <div class="row mb-2 tipos-cargas">
          <div class="col-9">
            <p>
              A carga de cotistas é obtida automaticamente a cada 30 minutos,
              porém, se preferir, clique no botão para executar a carga
              manualmente. Os dados serão atualizados em aproximadamente 1
              minuto.
            </p>
          </div>
          <div class="col-3">
            <input
              type="button"
              value="Obter Carga de Cotistas (JCOT)"
              class="btn btn-primary"
              [disabled]="!shareholdersEnabled"
              (click)="getShareholders()"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="card mt-3">
      <div class="card-header text-uppercase">Fundos (JCOT)</div>
      <div class="card-body">
        <div class="row mb-2 tipos-cargas">
          <div class="col-9">
            <p>
              A carga de fundos é obtida automaticamente a cada 30 minutos,
              porém, se preferir, clique no botão para executar a carga
              manualmente. Os dados serão atualizados em aproximadamente 1
              minuto.
            </p>
          </div>
          <div class="col-3">
            <input
              type="button"
              value="Obter Carga de Fundos (JCOT)"
              class="btn btn-primary"
              [disabled]="!acquiredFundsEnabled"
              (click)="getAcquiredFunds()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
